import styled from 'styled-components';

export const SelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.sm};
  min-width: 200px;
  max-width: 320px;
`;

export const Label = styled.span`
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-weight: 500;
  font-size: ${(props) => props.theme.fontSize.sm};
  color: ${(props) => props.theme.colors.davysGrey};
  white-space: nowrap;
`;
